import { useCallback, useMemo } from 'react';
import { useQueryParams } from './useQueryParams';
const slugify = (name) => {
    const slug = name
        // remove not allowed characters
        .replace(/[^\w\s$*_+~()'"!\-:@]/g, '')
        // trim leading/trailing spaces
        .trim()
        // convert spaces
        .replace(/[-\s]+/g, '-');
    return slug.toLowerCase();
};
export const useQueryParam = ({ name, property }, { navigationMode = 'push', parseOptions, stringifyOptions, } = {}) => {
    const [queryParams, setQueryParams] = useQueryParams({
        navigationMode,
        parseOptions,
        stringifyOptions,
    });
    const firstLevel = slugify(name);
    const secondLevel = property ? slugify(property) : undefined;
    const value = useMemo(() => {
        const queryParam = queryParams[firstLevel];
        if (secondLevel) {
            return queryParam === null || queryParam === void 0 ? void 0 : queryParam[secondLevel];
        }
        return queryParam;
    }, [firstLevel, secondLevel, queryParams]);
    const setValue = useCallback((newValue) => {
        var _a;
        if (!secondLevel) {
            setQueryParams({
                [firstLevel]: newValue,
            });
            return;
        }
        const queryParam = (_a = queryParams[firstLevel]) !== null && _a !== void 0 ? _a : {};
        if (typeof queryParam === 'object') {
            setQueryParams({
                [firstLevel]: {
                    ...queryParam,
                    [secondLevel]: newValue,
                },
            });
        }
    }, [firstLevel, secondLevel, queryParams, setQueryParams]);
    return [value, setValue];
};
//# sourceMappingURL=useQueryParam.js.map